import { render } from "./NoticiasView.vue?vue&type=template&id=a43180c2&scoped=true"
import script from "./NoticiasView.vue?vue&type=script&lang=js"
export * from "./NoticiasView.vue?vue&type=script&lang=js"

import "./NoticiasView.vue?vue&type=style&index=0&id=a43180c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43180c2"]])

export default __exports__